module.exports = __webpack_public_path__ + "static/media/icon-csv.96bd0e88.svg";